"use client"

import { preload } from "react-dom"

/**
 * Emits the image preload for a hero, from a client component on purpose.
 *
 * In a server component, both a `react-dom` `preload()` call and a host
 * `<link rel="preload">` become a hint that travels in the RSC payload and
 * fires as soon as that payload is fetched — including a `<Link>` prefetch —
 * so every page linking to a hero page downloaded its full-width hero
 * (measured 2026-10-11: 39 article heroes, 5 MB, on `/insights`). A client
 * component is only a reference in that payload: `preload()` runs when the
 * page itself renders. On a direct load that is the server render, so the
 * link still goes out with the other high-priority preloads at the top of
 * the HTML head.
 */
export function HeroPreloadLink({
  href,
  imageSrcSet,
  imageSizes = "100vw",
  crossOrigin,
  media,
}: {
  href: string
  imageSrcSet: string
  imageSizes?: string
  crossOrigin?: "anonymous"
  media?: string
}) {
  preload(href, {
    as: "image",
    imageSrcSet,
    imageSizes,
    fetchPriority: "high",
    ...(crossOrigin ? { crossOrigin } : {}),
    ...(media ? { media } : {}),
  })
  return null
}
